import { PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js"
import { Col, Row } from "antd"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"

import { Button } from "components/Button"
import { Modal } from "components/Modal/Modal"
import { languages } from "lib/languages"
import { CardsStore } from "types/store"

import actions from "./services/actions"
import styles from "./Stripe.module.scss"

export const CreditCardForm: React.FC<CardsStore> = (props): JSX.Element => {
  const stripe = useStripe()
  const elements = useElements()
  const [loading, setLoading] = useState(props.loading)
  const [modalVisible, setModalVisible] = useState(false)
  const [paymentElementKey, setPaymentElementKey] = useState(0)
  const dispatch = useDispatch()

  useEffect(() => {
    setLoading(props.loading)
  }, [props.loading])

  useEffect(() => {
    !props.clientSecret && props.create()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.clientSecret])

  const closeModal = () => {
    setModalVisible(false)
    setPaymentElementKey((k) => k + 1)
  }

  const submit = async () => {
    setLoading(true)
    if (!stripe || !elements) return

    if (props.clientSecret) {
      dispatch(actions.hasStripeError(false))

      const { error: submitError } = await elements.submit()
      if (submitError) {
        dispatch(actions.hasStripeError(true))
        dispatch(actions.attachError(submitError.message || languages.setupIntentErrorStripe))
        setLoading(false)
        return
      }

      stripe
        .confirmSetup({
          elements,
          clientSecret: props.clientSecret,
          confirmParams: {
            payment_method_data: {
              billing_details: {
                name: `${props.patient.firstname} ${props.patient.lastname}`,
              },
            },
          },
          redirect: "if_required",
        })
        .then((response) => {
          const { setupIntent, error } = response
          if (error) {
            dispatch(actions.hasStripeError(true))
            dispatch(actions.attachError((error.message as string) || languages.setupIntentErrorStripe))
          } else if (setupIntent) {
            props.attach({ setupintent_id: setupIntent.id })
            closeModal()
          }
        })
        .catch(() => {
          dispatch(actions.hasStripeError(true))
          dispatch(actions.attachError(languages.genericErrorStripe))
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }

  return (
    <div className={styles.AddCardButton} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Button type="primary" size="xsmall" onClick={() => setModalVisible(true)}>
        {languages.add}
      </Button>
      <Modal
        visible={modalVisible}
        title={languages.add}
        closable
        onClose={closeModal}
        onCancel={closeModal}
        onAccept={submit}
        loading={loading}
        acceptText={languages.add}
        acceptButtonProps={{ type: 'primary' }}
      >
        <Row
          gutter={[10, 30]}
          justify="center"
          style={{ padding: "20px 0" }}
        >
          <Col span={22}>
            <PaymentElement
              key={paymentElementKey}
              options={{
                fields: {
                  billingDetails: {
                    name: "never",
                  },
                },
              }}
            />
          </Col>
        </Row>
      </Modal>
    </div>
  )
}
